import React from "react";
// import Divider from "@mui/material/Divider";

const Footer = () => {
  return (
    <section id="Footer" className="footer-container">
      {/* <Divider sx={{ borderColor: "#4682b4", borderWidth: 1 }} /> */}
      <h3 className="josefin-sans-text footer-heading">
        © 2024 - 2025 All rights reserved - Swamy's Hot Foods.
      </h3>
      <h3 className="josefin-sans-text footer-heading">
        Made with 💗 by CVS CHARAN
      </h3>
    </section>
  );
};

export default Footer;
